import FaceIcon from '@mui/icons-material/Face';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

type Props = {
  mock: boolean;
  starting: boolean;
  onStart: () => void;
};

const TIPS: Array<{ icon: ReactNode; text: string }> = [
  { icon: <LightModeOutlinedIcon />, text: 'Fique num lugar bem iluminado, com a luz de frente' },
  { icon: <FaceIcon />, text: 'Só você na câmera, rosto inteiro dentro do oval' },
  { icon: <VisibilityOffOutlinedIcon />, text: 'Tire óculos escuros, boné e máscara' },
  { icon: <PhoneIphoneOutlinedIcon />, text: 'Segure o aparelho na vertical, na altura dos olhos' },
];

/** Preparação da selfie: o que vai acontecer, dicas e um único botão. */
export function SelfieIntro({ mock, starting, onStart }: Props) {
  return (
    <>
      <Box className="selfie-hero" aria-hidden>
        <Box className="selfie-hero__oval" />
        <Box className="selfie-hero__badge">{mock ? 'Captura simples' : 'Prova de vida'}</Box>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Typography variant="h2">{mock ? 'Hora da selfie' : 'Vamos confirmar que é você'}</Typography>
        <Typography color="text.secondary">
          {mock
            ? 'Modo de desenvolvimento: uma foto simples, sem prova de vida.'
            : 'A câmera vai pedir para você aproximar o rosto e, por alguns segundos, a tela muda de cor. Leva menos de 15 segundos.'}
        </Typography>
      </Box>

      <Box component="ul" className="selfie-tips">
        {TIPS.map((tip) => (
          <Box component="li" key={tip.text} className="selfie-tips__item">
            <Box className="selfie-tips__icon">{tip.icon}</Box>
            <Typography variant="body2">{tip.text}</Typography>
          </Box>
        ))}
      </Box>

      {!mock && (
        <Typography variant="body2" color="text.secondary" className="selfie-note">
          As cores que piscam podem incomodar pessoas fotossensíveis. Se for o seu caso, peça ajuda a
          quem está conduzindo a demonstração.
        </Typography>
      )}

      <Box sx={{ mt: 'auto', pb: 2 }}>
        <Button variant="contained" fullWidth disabled={starting} onClick={onStart} data-testid="selfie-start">
          {starting ? 'Preparando a câmera…' : mock ? 'Abrir a câmera' : 'Iniciar prova de vida'}
        </Button>
      </Box>
    </>
  );
}
